<template>
  <div>
    <!-- 기본 -->
    <basic-oneto-one-reg v-if="!isLaunchpack"></basic-oneto-one-reg>

    <!-- 마스터 백오피스 -->
    <launchpack-oneto-one-reg v-if="isLaunchpack"></launchpack-oneto-one-reg>
  </div>
</template>

<script>

  import BasicOnetoOneReg from "./BasicOnetoOneReg";
  import LaunchpackOnetoOneReg from "./LaunchpackOnetoOneReg";

  export default {
    layout: 'Main',
    components: {
      LaunchpackOnetoOneReg,
      BasicOnetoOneReg
    },
    data() {
      return {
      }
    },
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
